import React, {useEffect,useState} from 'react';
import Check from '../../assests/icons/check';
import classNames from 'classnames';

const MessagesSummary = (props) => {
  const [panelsData, changePanel] = useState(props);

  useEffect(() => {
    changePanel(props);
  }, [props]);
  return (
    <div className={classNames('message-infos', props.compClass)}>
      
          <div className="box">
            <h3 className="box__title">Özet</h3>
            <div
              className={classNames('message-infos__item', {
                filled: panelsData?.title,
              })}
            >
              <Check />
              <span>Ünvanınız</span>
              {panelsData?.title ? <p>{panelsData?.title}</p> : <p>Seçim Yapılmadı</p>}
            </div>
            <div
              className={classNames(
                'message-infos__item',
                { filled: panelsData?.message },
                { ellipsis: (panelsData?.message &&  panelsData?.message.length > 59)}
              )}
            >
              <Check />
              <span>Mesajınız</span>
              {panelsData?.message ? <p>{panelsData?.message}</p> : <p>Seçim Yapılmadı</p>}
            </div>
            <div
              className={classNames('message-infos__item', {
                filled: panelsData?.receivers,
              })}
            >
              <Check />
              <span>Alıcılar</span>
              {panelsData?.receivers ? (
                <p>{panelsData?.receivers} kişi</p>
              ) : (
                <p>Seçim Yapılmadı</p>
              )}
            </div>
            <div
              className={classNames('message-infos__item', {
                filled: panelsData?.deliveryTime,
              })}
            >
              <Check />
              <span>Gönderim Zamanı</span>
              {panelsData?.deliveryTime ? (
                <p>{panelsData?.deliveryTime}</p>
              ) : (
                <p>Seçim Yapılmadı</p>
              )}
            </div>
            <div
            className={classNames('message-infos__item', {
              filled: panelsData?.reportName,
            })}
          >
            <Check />
            <span>Rapor Adı</span>
            {panelsData?.reportName ? (
              <p>{panelsData?.reportName}</p>
            ) : (
              <p>Seçim Yapılmadı</p>
            )}
          </div>
          <div
            className={classNames('message-infos__item', {
              filled: panelsData?.numbersOfSms,
            })}
          >
            <Check />
            <span>Harcanacak Kredi</span>
            {panelsData?.numbersOfSms ? (
              <p>{panelsData?.numbersOfSms} kredi</p>
            ) : (
              <p>Seçim Yapılmadı</p>
            )}
          </div>
          </div>
          
        
    </div>
  );
};

export default MessagesSummary;
